module.exports = __webpack_public_path__ + "media/tao.34b6f603.mp3";